import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../core/animations';
import { MatSnackBar } from '@angular/material';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-add-to-blaclist',
  templateUrl: './add-to-blaclist.component.html',
  styleUrls: ['./add-to-blaclist.component.scss'],
  animations: fuseAnimations
})
export class AddToBlaclistComponent implements OnInit {
  form: FormGroup;
  formErrors: any;
  input: any;
  sub: any;
  badwords = [];
  filteredBadwords = [];
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private afs: AngularFirestore,
    public snackBar: MatSnackBar,
    private router: Router) {

    this.formErrors = {
      badword: {}
    };

    this.sub = this.afs.collection('blacklist').valueChanges().subscribe(word => {
      this.badwords = [];
      word.forEach(words => {

        this.badwords.push(words['word'])
      });
    });
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      badword: ['', Validators.required]
    });
  }

  remove(key) {
    this.afs.collection('blacklist').ref.where('word', '==', key).get().then((wordKey) => {
      this.afs.collection('blacklist').doc(wordKey.docs[0].id).delete();
    });

  }

  ngOnDestroy(): void {

    try {
      this.sub.unsubscribe();
    } catch (e) { }
  }

  inputKeyUp(a) {
    this.filteredBadwords = this.badwords.filter(
      word => {
        console.log(word);

        return word.indexOf(this.input) > -1
      });
  }

  create(word) {
    if (!word.badword) {
      return;
    }
    this.afs.collection('blacklist').add({ word: word.badword })
      .then(() => {
        this.snackBar.open('Kelime Eklendi', 'Bilgi', {
          duration: 3000
        });
        this.form = this.formBuilder.group({
          badword: ['', Validators.required]
        });
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/add-to-blaclist/add-to-blaclist.component.ts